(ns web3.auth.lazy-api
  (:require [shadow.lazy :as lazy]))

(def auth-api (lazy/loadable web3.auth.api/API))

(defn loaded? [] (lazy/ready? auth-api))

(defn call-if-loaded
  "Calls function defined in web3.auth.api, if it is loaded."
  [k & args]
  (when (loaded?)
    (let [f (@auth-api k)]
      (apply f args))))

(defn call!
  "Like `call` but will throw if auth is not present."
  [k & args]
  @auth-api
  (apply call-if-loaded k args))
